export const COOKIE_PATH = '/';
export const COOKIE_DOMAIN = '.lcl.fr';
export const MARKET_COOKIE_NAME = 'lclgen';
export const SMART_APP_BANNER_COOKIE_NAME = 'lclsmartbanner';
